import React from "react";
import styled from "styled-components";
import {InlineHeartComp} from "../howIsItWorking/HowIsItWorking";
import TextArea from "../textArea/TextArea";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";
import SmoothScrollLink from "../smoothScrollLink/SmoothScrollLink";

const AboutUsHeroAreaContent = () => {
    return (
        <AboutUsHeroAreaContentWrapper>
            <TextArea>
                <h1>Hakkımızda</h1>
                <p>
                    Pembe Panjur, 2010 yılında, "Mutlu hayatların başlangıcı" sloganıyla binlerce
                    bekar insanın ciddi ilişki ve evlilik arayışına hizmet etmek amacıyla yayına girdi. Teknolojik
                    altyapısıyla başarılı bir eşleştirme sistemini hayata geçiren Pembe Panjur, o günden bu yana
                    istikrarlı ve sürdürülebilir büyüme ile üye sayısını 10 milyonun üzerine çıkardı. Bu sayıyla
                    Türkiye'nin en büyük evlilik sitesi unvanını elde etti.
                </p>
                <p>
                    Bugün yalnızca Türkiye'den değil, dünyadan da pek çok Pembe Panjur üyesi yeni birlikteliklerine
                    Pembe Panjur ile adım atıyor. Pembe Panjur'u diğer arkadaşlık ve evlilik sitelerinden ayrıştıran
                    eşleştirme sistemi, çiftlerin uyumlu birliktelik kurma olasılığını artırıyor. Pembe Panjur,
                    profesyonel, hümanist, değerlere saygılı, hizmette kaliteyi hedefleyen bir yaklaşım sergilerken,
                    evlenen üyelerinin mutlu günlerine de şahitlik edip destek olma misyonunu taşıyor.
                </p>
                <ul>
                    <li>
                        <InlineHeartComp/>
                        <SmoothScrollLink href={'#about-us-title'} offset={0}>
                            Nasıl Çalışır
                        </SmoothScrollLink>
                    </li>
                    <li>
                        <InlineHeartComp/>
                        <SmoothScrollLink href={'#why-pink-blind-container'} offset={0}>
                            Neden Pembe Panjur
                        </SmoothScrollLink>
                    </li>
                    <li>
                        <InlineHeartComp/>
                        <SmoothScrollLink href={'#customer-service'} offset={0}>
                            Müşteri Hizmetleri
                        </SmoothScrollLink>
                    </li>
                    <li>
                        <InlineHeartComp/>
                        <SmoothScrollLink href={'#security-wrapper'} offset={0}>
                            Güvenlik
                        </SmoothScrollLink>
                    </li>
                    <li>
                        <InlineHeartComp/>
                        <SmoothScrollLink href={'#mobile-app'} offset={0}>
                            Mobil Uygulama
                        </SmoothScrollLink>
                    </li>
                </ul>
            </TextArea>
        </AboutUsHeroAreaContentWrapper>
    )
}

const AboutUsHeroAreaContentWrapper = styled.div`
    flex: 1.3;
    position: relative;
    display: flex;
    align-items: center;


    > div {
        display: flex;
        flex-direction: column;
        background-color: unset;
        padding: 0 40px 20px 25px;
        width: 100%;

        @media ${deviceMax.tablet} {
            padding: 0 30px 20px;
        }

        > h1 {
            font-weight: 800;
            font-size: 32px;
            line-height: 40px;
            letter-spacing: 0;
            text-transform: uppercase;
            color: ${Colors.white};
            margin-top: 0;
            margin-bottom: 17px;

            @media ${deviceMax.laptop} {
                text-align: center;
                font-size: 24px;
                line-height: 28px;
                display: block;
                width: 100%;
            }
        }

        > p {
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0;
            color: ${Colors.white};
            margin-top: 0;

            @media ${deviceMax.laptop} {
                text-align: center;
            }
        }

        > ul {
            > li {
                font-weight: 800;
                font-size: 20px;
                line-height: 22px;
                letter-spacing: 0;
                color: ${Colors.white};
                padding-left: 35px;

                > a {
                    display: inline-block;
                    font-weight: 800;
                    font-size: 20px;
                    line-height: 22px;
                    letter-spacing: 0;
                    color: ${Colors.white};
                    text-decoration: none;
                    transition: all 0.3s ease-in-out;

                    &:hover {
                        transform: scale(1.05);
                    }

                    @media ${deviceMax.laptop} {
                        font-size: 18px;
                    }
                }

                > div {
                    &:before, &:after {
                        background: ${Colors.white};
                    }
                }

                @media ${deviceMax.laptop} {
                    font-size: 18px;
                    padding-left: 55px;
                }
            }
        }
    }

`

export default AboutUsHeroAreaContent;
